import checkStopType from "@/lib/stopTypeChecker";

export function getEffectiveStopType(stopOrId, fallbackType = "bus") {
  const stopId =
    typeof stopOrId === "object" ? stopOrId?.stop_id || stopOrId?.id : stopOrId;
  const explicitType =
    typeof stopOrId === "object" ? stopOrId?.stop_type || stopOrId?.type : null;
  const inferredType = checkStopType(stopId);

  return explicitType || inferredType || fallbackType;
}

export function getStopTypeColorClass(stopType) {
  switch (stopType) {
    case "train":
      return "text-green-500";
    case "cable_car":
      return "text-red-500";
    case "ferry":
      return "text-blue-500";
    case "bus":
    default:
      return "text-orange-400";
  }
}
